import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    LinearProgress,
    Button
} from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmailIcon from '@mui/icons-material/Email';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
const SubscriptionInfo = ({ user }) => {
    // Helper function to format subscription plan name
    const formatPlanName = (plan) => {
        return plan.charAt(0).toUpperCase() + plan.slice(1);
    };

    // Helper function to get total emails based on plan
    const getTotalEmails = (plan) => {
        switch (plan) {
            case 'master':
                return 40;
            case 'pro':
                return 20;
            case 'basic':
                return 10;
            default:
                return 0;
        }
    };

    const totalEmails = getTotalEmails(user?.subscription_plan);
    const emailProgress = (user?.emailsRemaining / totalEmails) * 100;

    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <WorkspacePremiumIcon color="primary" sx={{ fontSize: 32 }} />
                        <Box>
                            <Typography variant="h6">
                                {formatPlanName(user?.subscription_plan || 'Basic')} Plan
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Your current subscription
                            </Typography>
                        </Box>
                    </Box>
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to="/pricing"
                        sx={{ fontSize: 12}}
                        endIcon={<KeyboardDoubleArrowUpIcon/>}
                    >
                        Upgrade Plan
                    </Button>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 1
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <EmailIcon color="primary" />
                            <Typography variant="body2">
                                Remaining Emails
                            </Typography>
                        </Box>
                        <Typography variant="body2">
                            {user?.emailsRemaining} / {totalEmails}
                        </Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={emailProgress}
                        sx={{ height: 8, borderRadius: 4 }}
                    />
                </Box>
            </CardContent>
        </Card>
    );
};

export default SubscriptionInfo;